export interface PrintJobCompletedPayload {
    jobId: string;
    status: 'COMPLETED' | 'FAILED';
    success: boolean;
    data?: string; // Base64-encoded PDF
    error?: string;
}